/**
 * Construye el mapa projectGroupId -> URL de PDF final a partir de los editable
 * reports de un proyecto.
 *
 * Cada EditableReport está asociado a UN grupo (envío), así que un proyecto tiene
 * varios reports. Hay que recoger TODOS los del proyecto y agregar sus grupos, no
 * solo el primero (bug: el botón "Descargar informe" aparecía en un único grupo).
 */

export interface ReportGroupPdf {
  projectGroupId: string;
  finalPdfUrl?: string | null;
}

export interface EditableReportLike {
  projectId: string | number;
  groups?: ReportGroupPdf[];
}

export const buildGroupPdfMap = (
  reports: EditableReportLike[],
  projectId: string | number
): Record<string, string> => {
  const map: Record<string, string> = {};

  reports
    .filter(report => String(report.projectId) === String(projectId))
    .forEach(report => {
      report.groups?.forEach(group => {
        if (group.finalPdfUrl) {
          map[group.projectGroupId] = group.finalPdfUrl;
        }
      });
    });

  return map;
};
